import { Service } from '@core/models/home.model';

export const SERVICES_DATA_ES: Service[] = [
  {
    title: 'Envíos puerta a puerta',
    description:
      'Recogemos tu equipaje desde tu ubicación y lo entregamos directamente en tu destino.',
    image: './images/backgrounds/dark-sky.png',
  },
  {
    title: 'Envíos internacionales',
    description: 'Envíe sus maletas a cualquier parte del mundo con nuestra red global de socios.',
    image: './images/backgrounds/light-sky.png',
  },
  {
    title: 'Manejo seguro',
    description:
      'Sus pertenencias están completamente aseguradas y se manejan con el máximo cuidado durante todo el transporte.',
    image: './images/backgrounds/sunrise.png',
  },
  {
    title: 'Seguimiento en tiempo real',
    description: 'Rastrea tu envío 24/7 con nuestro avanzado sistema de rastreo.',
    image: './images/backgrounds/northern-lights.png',
  },
];

export const SERVICES_DATA_EN: Service[] = [
  {
    title: 'Door-to-door shipping',
    description:
      'We pick up your luggage from your location and deliver it directly to your destination.',
    image: './images/backgrounds/dark-sky.png',
  },
  {
    title: 'International shipping',
    description: 'Send your bags anywhere in the world with our global network of partners.',
    image: './images/backgrounds/light-sky.png',
  },
  {
    title: 'Secure handling',
    description:
      'Your belongings are fully insured and handled with the utmost care throughout transport.',
    image: './images/backgrounds/sunrise.png',
  },
  {
    title: 'Real-time tracking',
    description: 'Track your shipment 24/7 with our advanced tracking system.',
    image: './images/backgrounds/northern-lights.png',
  },
];
